<template>
    <RallyNav v-if="!this.$refs.RallyNav"/>
  <div>
    <main class="events index">
      <div class="dropdown-select" v-if="!rallyId">
        <div class="dropdown">
          <button class="dropdown-toggle" type="button" @click="toggleDropdown">
            <i class="fas fa-calendar-check"></i>
            {{ dropdownLabel }}
          </button>
          <div class="dropdown-menu" :class="{ 'show': isDropdownOpen }">
            <label v-for="membership in sortedMemberships" :key="membership.attributes['rally-id']" class="dropdown-item">
              <input type="checkbox" :value="membership.attributes['rally-id']" @change="updateSelectedRallyIds($event, membership.attributes['rally-id'])" :checked="selectedRallyIds.includes(membership.attributes['rally-id'])" />
              {{ membership.attributes.title }}
            </label>
          </div>
        </div>
      </div>
      <ToolBar :options="toolbarOptions" v-on:perform="perform" />
      <section class="content-area">
        <div class="calendar_actions">
          <div>Time Zone: {{timeZone}}</div>
          <div>
            <i class="fas fa-print" @click="printCalendar" style="margin-right: 20px; font-size: 1.6rem"></i>
            <i class="fas fa-calendar-plus" @click="openDeleteModal"  style="margin-right: 5px; font-size: 1.6rem"></i>
          </div>
        </div>
        <FullCalendar :rallyId="this.rallyId" ref="fc"
                      :options="calendarOptions.calendarOptions" ></FullCalendar>
      </section>
    </main>
    <div :class="[{ open: subscribeModalStatus }, 'modal', ]" >
      <div class="shadow" @click="closeDeleteModal"></div>
      <div class="body" style="width:100%; overflow: scroll;">
        <i class="fal fa-times exit" @click="closeDeleteModal"></i>
        <div v-if="subscriptionShowDetails === 'main'">
          <div class="heading">Subscribe to this Calendar</div>
          <p>Please copy this link and follow the directions for your calendar of choice:</p>
          <div>
            <input type="text" :value="subscribeLink" class="calLink" readonly/>
          </div>
          <p>Select your calendar to follow instructions</p>
          <div class="calBox">
            <div class="calItem" @click="subscriptionShowDetails = 'ical'">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="56" height="59" xml:space="preserve" version="1.1" viewBox="0 0 56 59">
    <image width="56" height="59" xlink:href="data:image/png;base64,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"/>
  </svg>
              <p>iCal</p>
            </div>
            <div class="calItem" @click="subscriptionShowDetails = 'gcal'">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="60" height="54" xml:space="preserve" version="1.1" viewBox="0 0 60 54">
    <image width="60" height="54" xlink:href="data:image/png;base64,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"/>
  </svg>
              <p>Google Calendar</p>
            </div>
            <div class="calItem" @click="subscriptionShowDetails = 'outlook2007'">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="75" height="60" xml:space="preserve" version="1.1" viewBox="0 0 75 60">
    <image width="75" height="60" xlink:href="data:image/png;base64,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"/>
  </svg>
              <p>Outlook 2007</p>
            </div>
            <div class="calItem" @click="subscriptionShowDetails = 'outlook2010'">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="60" height="60" xml:space="preserve" version="1.1" viewBox="0 0 60 60">
    <image width="60" height="60" xlink:href="data:image/png;base64,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"/>
  </svg>
              <p>Outlook 2010</p>
            </div>
          </div>
        </div>
        <div v-if="subscriptionShowDetails === 'ical'">
          <div class="heading">iCalendar</div>
          <p>To subscribe to this Rallyhood calendar using Apple Calendar, please copy this link and follow the instructions below:</p>
          <div>
            <input type="text" :value="subscribeLink" class="calLink" readonly/>
          </div>
          <div>
            <p>iCalendar</p>
            <ul>
              <li>1. Open Calendar</li>
              <li>2. Choose File > New Calendar Subscription</li>
              <li>3. Enter the Rallyhood calendar URL then click 'Subscribe'</li>
              <li>4. Complete the remaining steps to set up your calendar</li>
              <li>5. Click 'OK'</li>
            </ul>
          </div>
        </div>
        <div v-if="subscriptionShowDetails === 'gcal'">
          <div class="heading">Google Calendar</div>
          <p>To subscribe to this Rallyhood calendar using Google, please copy this link and follow the instructions below:</p>
          <div>
            <input type="text" :value="subscribeLink" class="calLink" readonly/>
          </div>
          <div>
            <p>Google Calendar</p>
            <ul>
              <li>1. Log into your Google account.</li>
              <li>2. Click 'Calendar' on the top navigation bar.</li>
              <li>3. Click the drop-down arrow on the right, under 'Other Calendars.'</li>
              <li>4. Click 'Add by URL.'</li>
              <li>5. Click 'Add Calendar.'</li>
            </ul>
          </div>
        </div>
        <div v-if="subscriptionShowDetails === 'outlook2007'">
          <div class="heading">Outlook 2007</div>
          <p>To subscribe to this Rallyhood calendar using Outlook 2007, please copy this link and follow the instructions below:</p>
          <div>
            <input type="text" :value="subscribeLink" class="calLink" readonly/>
          </div>
          <div>
            <p>Outlook 2007</p>
            <ul>
              <li>1. Select 'File', and then 'Data File Management.'</li>
              <li>2. Select the 'Internet Calendars' tab and click 'New.'</li>
              <li>3. Paste the URL into the field. Hit 'Add.'</li>
              <li>4. Change the name of the calendar if necessary, it will display next to 'Folder Name.'</li>
              <li>5. Add a description to make the calendar easy to identify. Check whether you want attachments to download from the Internet calendar under 'Attachments.'</li>
              <li>6. After the calendar is updated, it will display under 'Other Calendars' in the Calendars section of Outlook 2007.</li>
            </ul>
          </div>
        </div>
        <div v-if="subscriptionShowDetails === 'outlook2010'">
          <div class="heading">Outlook 2010</div>
          <p>To subscribe to this Rallyhood calendar using Outlook 2010, please copy this link and follow the instructions below:</p>
          <div>
            <input type="text" :value="subscribeLink" class="calLink" readonly/>
          </div>
          <div>
            <p>Outlook 2010</p>
            <ul>
              <li>1. Open up your Outlook calendar, click the 'Home' tab on the Ribbon, and under Manage Calendars section, click on 'Open Calendar', and then 'From Internet.'</li>
              <li>2. Paste the link location into the 'New Internet Calendar' field then click 'Ok.'</li>
              <li>3. Click 'Yes' to the dialog box that comes up verifying you want to subscribe to it.</li>
              <li>4. After the calendar is updated, it will display under 'Other Calendars' in the Calendars section of Outlook 2010.</li>
            </ul>
          </div>
        </div>
        <div class="actions">
          <div class="left">
            <button class="secondary" @click="copy">Copy Link</button>
          </div>
          <div class="right subscribemodal">
            <button v-if="subscriptionShowDetails != 'main'" class="link" @click="subscriptionShowDetails = 'main'">Back</button>
            <button class="primary" @click="closeDeleteModal">Done</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import {router, timezoneMapping, railsTzToMomentTz, findDefaultChannelOfTypeForRally, RH_VUE_URL} from "../common";
//import '@fullcalendar/core/vdom';
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import { userInfo, syncTimezone } from "../common/user-info"
import jwt_decode from "jwt-decode";

export default {
  name: "CalendarPage",
  props: ["channel"],
  data() {
    return {
      dateClicked: null,
      rallyId: null,
      rallyIds: null, 
      tempKey: null,
      selectedRallyIds: [],
      isDropdownOpen: false,
      isLoading: true,
      subscribeModalStatus: false,
      subscriptionShowDetails: 'main',
      subscribeAuthToken: '',
      calendarLink: 'https://rallyhood.com/184638/events.ics?user[token]=&rh=1693570941',
    };
  },
  watch: {
    rallyIdsByUserId: function(newMap, oldMap) {
      this.fetchInitialCalendarEntries();
    },
    rallyIds(newValue, oldValue) {
      // Whenever rallyIds changes, force the recalculation of rallyIdsForFetch
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    myMemberships: function(newMap, oldMap) {
      this.fetchInitialCalendarEntries();
    },
    allContentByContextTypeAndId: function(newById, oldById) {
      let newObj = null
      Object.keys(newById).forEach(key => {
        if (newById[key]) {
          if (Array.isArray(newById[key])) {
            newById[key].forEach(o => {
              if (o.editMode && o.tempKey == this.tempKey){
                newObj = o
              }
            });
          }
        }
      })
      if (newObj){
        router.push({
          path: `/${this.$route.params.rallyId}/${this.$route.params.channelSlug}/${newObj.id}`,
          query: { dateClicked: this.dateClicked } // Replace 'yourDateValue' with the actual date value
        });
      }

    }
  },
  computed: {
    ...mapState("calendars", ["calendarEntries", "calendarEntriesById", "calendarEntriesByContentId"]),
    ...mapState("rallies", ["rallyIdsByUserId"]),
    ...mapState("memberships", ["myMemberships"]),
    ...mapState("user", ["usersById"]),
    ...mapState("contents", ["allContentByContextTypeAndId", "contentById"]),
    ...mapState("rallies", ["rallyChannelsByRallyId"]),
    ...mapState("shares", ["sharesByShareId", "sharesByContentId"]),
    user(){
      return userInfo()
    },
    subscribeLink() {
      if (this.isLoading) {
        return ''
      }
      const currentTimeInSeconds = Math.floor(Date.now() / 1000);
      if(this.rallyId){
        return RH_VUE_URL() + this.rallyId + "/events.ics?user[token]=" + this.subscribeAuthToken + "&rh=" + currentTimeInSeconds;
      } else {
        return RH_VUE_URL() + "users/" + userInfo().user_id + "/events.ics?user[token]=" + this.subscribeAuthToken + "&rh=" + currentTimeInSeconds;
      }
    },
    timeZone(){
        //const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
        //const localUserTzName = railsTzToMomentTz(userInfo().timezone)
        const dbTzName = railsTzToMomentTz(this.usersById[userInfo().user_id]?.attributes["time-zone"])
        //console.log("calendar using timezone: " + dbTzName +  " or  " + localUserTzName)
        //var tz = localUserTzName ? localUserTzName : dbTzName
        //return tz
        //let access_token = localStorage.getItem("at");
        //let decodedToken = jwt_decode(access_token);
        console.log("calendar using timezone: " + dbTzName)
        return dbTzName
    },
    sortedMemberships() {
      return this.sortMemberships(this.myMemberships);
    },
    dropdownLabel() {
      if (this.selectedRallyIds.length === 0) {
        return 'Rallies';
      } else if (this.selectedRallyIds.length === 1) {
        //const membership = this.getMembershipById(this.selectedRallyIds[0]);
        //return membership ? membership.attributes.title : '';
        return ''
      } else {
        return `${this.selectedRallyIds.length} Rallies`;
      }
    },
    channelId(){
      return this.channel.id
    },
    rallyIdsForFetch(){
      if (this.rallyId){
        //single rally mode
        return [parseInt(this.rallyId)]
      } else {

        // Assuming you have an array of objects called 'dataArray'

        const selectedRallyIds = this.rallyIds || this.myMemberships.map(object => object.attributes['rally-id']);
        const rallyIds = this.myMemberships.map(object => object.attributes['rally-id']);

        return selectedRallyIds
      }
    },
    convertedCalendarEntries() {
      var newEntries = []
      if (this.calendarEntries){
        this.calendarEntries.forEach(ce => {
          var nce = {...ce}
          if (ce.all_day == 1){
            nce["allDay"] = true
            nce["start"]= ce.start.split("T")[0]
            nce["end"]= ce.start.split("T")[0]
            if (ce.end && ce.end.indexOf("T") > 0){
              nce["end"]= ce.end.split("T")[0]
            }
            nce["backgroundColor"]=ce.event_color
          } else {
            nce["allDay"] = false
            nce["start"]=moment(ce.start_time).format("YYYY-MM-DD HH:mm")
            nce["end"]=moment(ce.end_time).format("YYYY-MM-DD HH:mm")
            nce["borderColor"]=ce.event_color

          }
          if (nce["title"]){
            newEntries.push(nce)
          }
        });
      }

      return newEntries
    },

    calendarOptions() {
      //if (railsTzToMomentTz(userInfo().timezone)){
       // moment.tz.setDefault(railsTzToMomentTz(userInfo().timezone))
      //}
      if (this.timeZone){
        moment.tz.setDefault(this.timeZone)
      }
      return {
        calendarOptions: {
          height: "100%",
          plugins: [
            dayGridPlugin,
            interactionPlugin, // needed for dateClick,
            listPlugin
          ],
          headerToolbar: {
            right: "next2",//,dayGridMonth,listWeek",
            left: "prev2",
            center: "title"
            //center: 'title'
            //center: 'dayGridMonth,timeGridWeek,timeGridDay'
          },
          initialView: "dayGridMonth",
          //initialEvents: this.calendarEntries, // alternatively, use the `events` setting to fetch from a feed
          events: this.convertedCalendarEntries,
          weekends: true,
          dayMaxEvents: true,
          displayEventTime: true,
          eventDidMount: this.eventDidMountCallback,
          eventClassNames: this.getEventClassNames,
          eventClick: async (info) => {
            var id = this.calendarEntriesById[parseInt(info.event.id)]["content_uid"]
            var theRallyId = window.location.href.split("/")[3];
            var eventType = this.calendarEntriesById[parseInt(info.event.id)].event_type;
            if (this.rallyId == null) {
              let props = info.event._def.extendedProps
              if (props.calendarable_type === 'Rally') {
                await this.fetchRalliesChannels({rallyId: props.calendarable_id})
                this.rallyId = props.calendarable_id
              }
            } else {
              await this.fetchRalliesChannels({rallyId: this.rallyId})
            }
            if (eventType == "PayableEvent" ) {
              let channel = this.rallyChannelsByRallyId[this.rallyId].find(channel => channel.attributes.type === 'Payables');
              if (channel && channel.attributes.slug && channel.attributes.slug.split("?").length > 1) {
                let s = channel.attributes.slug.split("?")
                router.push(`/${this.rallyId}/${s[0]}/${id}?${s[1]}`);
                return;
              }
            } else if (eventType == "ChildPayableEvent" || eventType == "DeadlineEvent") {
              let parentEvent = this.calendarEntriesById[parseInt(this.calendarEntriesById[parseInt(info.event.id)]["parent_event_id"])]//this.getParentEvent(this.calendarEntriesById[parseInt(info.event.id)]);
              id = parentEvent["content_uid"]
              let channel = this.rallyChannelsByRallyId[this.rallyId].find(channel => channel.attributes.type === 'Payables');
              if (channel && channel.attributes.slug && channel.attributes.slug.split("?").length > 1) {
                let s = channel.attributes.slug.split("?")
                router.push(`/${this.rallyId}/${s[0]}/${id}?${s[1]}`);
                return;
              }
              return;
              // The router.push is in the getParentEvent method for some reason...
              // TODO - figure out why this is here and if it's needed
              //let channel = this.rallyChannelsByRallyId[this.rallyId].find(channel => channel.attributes.type === 'Payables');
              //if (channel) {
              //  router.push(`/${theRallyId}/${channel.attributes.slug}/${parentEvent.id}`);
              //}
            }
            let channels = this.rallyChannelsByRallyId[this.rallyId]
            const calendarChannel = channels.find(channel => channel.attributes.type === 'Calendar');
            router.push(`/${this.rallyId}/${calendarChannel.attributes.slug}/${id}`)

            // change the border color just for fun
            info.el.style.borderColor = "red";
          },

          dateClick: (info) => {
            console.log("info " + info['date'])
            if (this?.channel.attributes?.editable){
              this.dateClicked = moment(info['date']).add(12, 'hours').format("MM/DD/YYYY")
              console.log("dateClicked " + this.dateClicked )
              this.newEvent();
            }
          },

          eventContent: function(info) {

            var insertedTime = '';
            if (info.event.title && !info.event.allDay  && (info.event._context.viewApi.type.includes('grid') || info.event._context.viewApi.type.includes('Grid'))) {
              let formattedTime;
              if (moment(info.event.start).minutes() === 0) {
                // If minutes are 00, show only the hour and 'a'/'p'
                formattedTime = moment(info.event.start).local().format('ha').replace('am', 'a').replace('pm', 'p');
              } else {
                // Otherwise, show hour, minutes, and 'a'/'p'
                formattedTime = moment(info.event.start).local().format('h:mma').replace('am', 'a').replace('pm', 'p');
              }

              insertedTime = formattedTime + " " ;
            }

            if (info.event.extendedProps['rsvp_flag'] === 1) {
              // Return HTML with the icon
              return { html: `<div>${insertedTime}<i class="fas fa-flag" style="font-size: .8rem;"></i> ${info.event.title}</div>` };
            } else {
              // Return HTML without the icon
              return { html: `<div>${insertedTime}${info.event.title}</div>` };
            }
          },
          customButtons: {
            prev2: {
              // this overrides the prev button
              click: () => {
                let calendarApi = this.$refs.fc.getApi();
                calendarApi.prev();
                this.fetchCalendarEntries({
                  rallyIds: this.rallyIdsForFetch,
                  from_date: moment(calendarApi.currentData.dateProfile.currentRange.start).format("YYYY-MM-DD"),
                  to_date: moment(calendarApi.currentData.dateProfile.currentRange.end).format("YYYY-MM-DD"),
                  //channelId: this.channelId
                });
              }
            },
            next2: {
              // this overrides the prev button
              click: () => {
                let calendarApi = this.$refs.fc.getApi();
                calendarApi.next();
                let rallyIds = this.selectedRallyIds;
                if (rallyIds.length === 0) {
                  rallyIds = this.rallyIdsForFetch; // Fallback to computed property
                }
                this.fetchCalendarEntries({
                  rallyIds: rallyIds,
                  from_date: moment(calendarApi.currentData.dateProfile.currentRange.start).format("YYYY-MM-DD"),
                  to_date: moment(calendarApi.currentData.dateProfile.currentRange.end).format("YYYY-MM-DD"),
                  //channelId: this.channelId
                });
              }
            }
          }
        }
      };
    },
    toolbarOptions() {
      let options = new Array();

      // Disable console errors for using TRUE and FALSE in examples.
      /* eslint-disable no-constant-condition */

      // Consult membership.role and channel.members_write
      if (this.rallyId && this?.channel.attributes?.writable) {
        options.push({
          onClick: "newEvent",
          params: { contentType: "CalendarEvent" },
          icon: "fa-plus-circle",
          label: "New Event"
        })
      }

      // Present for everyone
      options.push({
        onClick: "changeViewToListDay",
        params: { view: "listDay" },
        icon: "fa-list-ul",
        label: "List Day"
      })
      options.push({
        onClick: "changeViewToListWeek",
        params: { view: "listWeek" },
        icon: "fa-list-ul",
        label: "List Week"
      })
      options.push({
        onClick: "changeViewToListMonth",
        params: { view: "listMonth" },
        icon: "fa-list-ul",
        label: "List Month"
      })
      options.push({
        onClick: "changeView",
        params: { view: "dayGridMonth" },
        icon: "fa-calendar-alt",
        label: "Month View"
      })
      options.push({
        onClick: "changeView",
        params: { view: "dayGridWeek" },
        icon: "fa-calendar-week",
        label: "Week View"
      })
      options.push({
        onClick: "changeView",
        params: { view: "dayGridDay" },
        icon: "fa-calendar-day",
        label: "Day View"
      })
      /* TODO
      options.push({
        onClick: "openSubscribe",
        icon: "fa-calendar-plus",
        label: "Subscribe"
      })*/
      /*disabled for now, per Patti at May 17, 2022 meeting
      options.push({
        onClick: "triggerPrint",
        icon: "fa-print",
        label: "Print"
      })*/
      /*
      // This should only be true for rally admin.
      // if (chanObj.attributes.editable) {
        options.push({
          onClick: "openSettings",
          icon: "fa-cog",
          label: "Settings"
        });*/
      // }

      return options;
    }
  },

  async created() {
    await this.fetchUsersById({ userIds: [userInfo().user_id], loggedInUser: true});
    await syncTimezone();
    this.subscribeAuthToken = this.usersById[userInfo().user_id].attributes['auth-token']
    if (this.$route?.params?.rallyId){
      this.rallyId = this.$route.params.rallyId;
      await this.fetchInitialCalendarEntries();
      //setTimeout( function() {
      //this.fetchInitialCalendarEntries();
      //}.bind(this), 3000);
    } else {
      await this.fetchMyMemberships();
      await this.fetchInitialCalendarEntries();
      //setTimeout( function() {
      //this.fetchInitialCalendarEntries();
      //}.bind(this), 3000);
    }
    this.isLoading = false;
  },

  methods: {
    ...mapActions("calendars", ["fetchCalendarEntries"]),
    ...mapActions("rallies", ["fetchUserRallyIds", "fetchRalliesChannels"]),
    ...mapActions("contents", ["createContents", "fetchContentById"]),
    ...mapActions("memberships", ["fetchMyMemberships"]),
    ...mapActions("user", ["fetchUsersById"]),

    eventDidMountCallback(info) {
      if (!info.event.allDay) {

        // For non-all-day events, set the font color based on the event's 'event_color' attribute
        info.el.style.color = info.event.extendedProps.event_color;
        info.el.style.overflow = 'hidden';

        info.el.lastChild.style.color = info.event.extendedProps.event_color;

        var start_date = new Date(info.event.start);
        var end_date = new Date(info.event.end);
        let diff = new Date(end_date - start_date);
         diff = Math.floor(diff/1000/60/60/24);

        if (diff > 1) {
          info.el.lastChild.style.borderWidth = '0px';
        }
       // info.el.style.width = '100%';
      }
    },
    changeView(params) {
      this.$refs.fc.getApi().changeView(params.view);
    },
    changeViewToListDay() {
      this.$refs.fc.getApi().changeView('listDay');
    },
    changeViewToListWeek() {
      this.$refs.fc.getApi().changeView('listWeek');
    },
    changeViewToListMonth() {
      this.$refs.fc.getApi().changeView('listMonth');
    },
    async getParentEvent(event) {
      await this.fetchContentById({ id: event.content_uid,
        contentType: 'Event',
        contextRallyId: this.rallyId });
      let childEvent = this.contentById[event.content_uid];
      let childShare = this.contextShare(childEvent.id);
      await this.fetchContentById({ id: childShare.attributes['context-id'],
        //contextChannelId: this.channelId,
        contentType: 'Fundraiser',
        contextRallyId: this.rallyId })
      let parentEvent = this.contentById[childShare.attributes['context-id']];
      let channel = this.rallyChannelsByRallyId[this.rallyId].find(channel => channel.attributes.type === 'Payables');
      if (channel) {
        router.push(`/${this.rallyId}/${channel.attributes.slug}/${parentEvent.id}`);
      }
      return parentEvent;
    },
    contextShare(eventId) {
      var rallyId = this.rallyId
      if (this.shares(eventId) && this.shares(eventId).filter){
        return this.shares(eventId).filter(function(s) {
          return s.attributes['context-rally-id'] == parseInt(rallyId);
        })[0];
      } else {
        return {}
      }
    },
    shares(eventId){
      return this.sharesByContentId[parseInt(eventId)]
    },
    sortMemberships(memberships) {
      return memberships.slice().sort((a, b) => {
        const titleA = a.attributes && a.attributes.title ? a.attributes.title.toLowerCase(): "z";
        const titleB = b.attributes && b.attributes.title ? b.attributes.title.toLowerCase() : "z";
        if (titleA < titleB) {
          return -1;
        }
        if (titleA > titleB) {
          return 1;
        }
        return 0;
      });
    },
    printCalendar() {
      window.print();
    },
    getEventClassNames(info) {
      const classNames = [];

      if (info.event.allDay) {
        // Add class for all-day events
        classNames.push('all-day-event');
      } else {
        // Add class for non-all-day events
        // This was an attempt to set the font color of the event, but it didn't work. However, it does add the class to the event.
        // so I'm leaving this here in case we want to add any other styles to the class.
        classNames.push('timed-event');
      }
      return classNames.join(' ');
    },

    closeDeleteModal() {
      this.subscribeModalStatus = false;
    },
    openDeleteModal() {
      this.subscribeModalStatus = true;
    },
    copy(){
      navigator.clipboard.writeText(this.subscribeLink);
    },

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    updateSelectedRallyIds(event, rallyId) {
      //const selectedOptions = Array.from(event.target.selectedOptions);
      //this.selectedRallyIds = selectedOptions.map(option => option.value);

      const checkbox = event.target;
      if (checkbox.checked) {
        // Add rallyId to the array
        this.selectedRallyIds.push(rallyId);
      } else {
        // Remove rallyId from the array
        this.selectedRallyIds = this.selectedRallyIds.filter(id => id !== rallyId);
      }

      this.fetchInitialCalendarEntries()
    },
    intToHex(dec) {
      var result = (dec | 0).toString(16);
      if (result.length == 1) { result = ('0' + result) }
      return result.toLowerCase();
    },
    setRgba(hexColor, opacity) {
      if ( this.isEmpty(opacity) ) {
        opacity = "1.0"
      }

      var rgbColor = this.hexToRgb(hexColor)
      return 'rgba('+rgbColor.r+','+rgbColor.g+','+rgbColor.b+','+opacity+')'
    },
    hexToRgb(hex) {
      if ( this.isEmpty(hex) ) {
        hex = "#1C8291"
      }

      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
      });

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },
    isEmpty(value){
      return ( value === null || value === '' || value === 'undefined' || value === undefined );
    },
    refreshEvents(){
      //let calendar = this.$refs.fc.getApi()
    },
    fetchInitialCalendarEntries(){
      let rallyIds = this.selectedRallyIds;
      if (rallyIds.length === 0) {
        rallyIds = this.rallyIdsForFetch; // Fallback to computed property
      }
      this.fetchCalendarEntries({
        rallyIds: rallyIds,
        from_date: moment()
            .subtract(1, 'months')
            .startOf("month")
            .format("YYYY-MM-DD"),
        to_date: moment()
            .add(1, 'months')
            .endOf("month")
            .format("YYYY-MM-DD")
      });
    },
    log(message) {
      this.$log.debug(message);
    },
    eventRenderHook(info) {
    },
    newEvent() {
      this.tempKey = "TK" + Math.floor(Math.random() * 10000); 
      if (!this.dateClicked){
        this.dateClicked = moment(new Date()).format("MM/DD/YYYY")
      }
      this.content = {}
      this.content.attributes = {}
      this.content.attributes.title = ""
      this.content.attributes.body = "";
      this.content.tempKey = this.tempKey
      this.content.attributes.contentType = "Events"
      this.content.editMode = true
      this.createContents({  title:"",
        contextType: "Channel",
        type: "CalendarEvent",
        contentType: "Event",
        rallyId: this.rallyId,
        contextId: this.channelId,
        contextChannelId: this.channelId,
        contextRallyId:  this.rallyId,
        status:1,
        tempKey: this.tempKey,
        editMode: true });
    },
    openSubscribe() {
      //alert('TODO: David - rewrite subscription options');
    },
    perform(method, params) {
      // Execute whatever method name came from the ToolBar.
      params ? this[method](params) : this[method]();
    },
    triggerPrint() {
      setTimeout(() => {
        window.print();
      }, 100);
    },
  }
};

</script>

<style scoped>

.dropdown {
  position: relative;
  display: inline-block;
}
.dropdown-toggle {
  /* padding: 8px 20px; */
  border: 1px solid #ccc;
  background-color: #fff;
  cursor: pointer;
  height: 45px;
  position: absolute;
  z-index: 9;
  top: 20px;
  /* left: 10px; */
  width: 100px;
  font-size: .8rem;
}

.dropdown-menu {
  position: fixed;
  top: 185px;
  left: 25px;
  z-index: 1000;
  display: none;
  padding: 5px;
  background-color: #fff;
  border: 1px solid #ccc;
  max-height: 200px;
  overflow-y: auto;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  cursor: pointer;
}

.dropdown-item input[type="checkbox"] {
  margin-right: 8px;
}
</style>